import { Injectable } from '@angular/core';
import { Patient } from '../../../models/patient/patient.model';
import { BaseService } from '../../../shared/services/base.service';
import { PatientUrl } from '../../../shared/urls/patient.url';
import { UserUrl } from '../../../shared/urls/user.url';
import { RequestAppointmentUrl } from '../../../shared/urls/request-appointment.url';

@Injectable()
export class ListMemberService {
    constructor(public baseService: BaseService) {
    }

    getInit() {
        return this.baseService.getData(PatientUrl.PATIENT_INIT);
    }
    getCountryList() {
        return this.baseService.getData(UserUrl.GET_USER_COUNTRY_INIT);
    }
    importFileMember(param) {
        const url = RequestAppointmentUrl.IMPORT_FILE_EXCEL;
        return this.baseService.upload(url, param);
    }
    downloadFileTemplate() {
        const url = RequestAppointmentUrl.DOWNLOAD_FILE_TEMPLATE;
        return this.baseService.getAll(url);
    }
    addBooking(param) {
        const url = RequestAppointmentUrl.ADD_BOOKING;
        return this.baseService.postData(url, param);
    }
    addBookingCache(param) {
        const url = RequestAppointmentUrl.ADD_BOOKING_CACHE;
        return this.baseService.postData(url, param);
    }
    getBookingCache(id) {
        const url = RequestAppointmentUrl.GET_BOOKING_CACHE.replace('{centreId}', id);
        return this.baseService.getData(url);
    }
    addBookingGroup(param) {
        const url = RequestAppointmentUrl.ADD_GROUP_BOOKING;
        return this.baseService.upload(url, param);
    }
    getSexData(): any[] {
        return [
            {
                id: 0,
                name: 'Male'
            },
            {
                id: 1,
                name: 'Female'
            }
        ];
    }

     /**
     * return true if there are some duplicated records (same First Name, Surname and DOB)
     * else return false
     * @param list
     */
    isDuplicatePatientInList(list) {
        let isDuplicate = true;
        const valueArr = list.map(function(item) {
            return (item['firstName'] + item['surName'] + item['dateOfBirth']).toLowerCase();
        });
        console.log('valueArr', valueArr);
        isDuplicate = valueArr.some(function(item, idx){
            return valueArr.indexOf(item) !== idx;
        });
        return isDuplicate;
    }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/request-appointment/list-member/list-member.service.ts